export default __webpack_public_path__ + "static/media/AB Bank.5f56f5cc.png";